import { render } from "./HeroiconsOutlineShieldExclamation.vue?vue&type=template&id=4b3e1ec4"
const script = {}

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineShieldExclamation.vue"]])

export default __exports__